"use client"

import { DDOPTrackPage } from "@repo/shared"
import { usePathname } from "next/navigation"
import { useEffect, useRef } from "react"

/**
 * 页面级统计埋点组件
 *
 * 只监听路由路径（pathname）变化：
 * - 不再关心 searchParams 的变化
 * - 每次路由路径变化时，仅在首次变化时触发一次埋点（避免严格模式下的双调用）
 */
const PageTracker = () => {
  const pathname = usePathname()
  const lastTrackedPathRef = useRef<string | null>(null)

  useEffect(() => {
    // 路由路径未变化，不重复触发
    if (lastTrackedPathRef.current === pathname) {
      return
    }

    // 记录当前路径（包括首次进入页面），并触发一次埋点
    lastTrackedPathRef.current = pathname
    void DDOPTrackPage()
  }, [pathname])

  return null
}

export default PageTracker
